module.exports = __webpack_public_path__ + "img/switzerland.95b9ca55.png";